import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import {
  RadarRing,
  RadarQuadrant,
  RadarEntry,
  TechRadarLoaderResponse,
} from '@backstage-community/plugin-tech-radar-common';
import { Config } from '@backstage/config';
import { IdentityApi } from '@backstage/core-plugin-api';

export class TechRadarClient implements TechRadarApi {
  backendBaseUrl: string;
  identityApi: IdentityApi;

  constructor(config: Config, identityApi: IdentityApi) {
    this.backendBaseUrl = config.get('backend.baseUrl');
    this.identityApi = identityApi;
  }

  async load(id: string | undefined): Promise<TechRadarLoaderResponse> {
    const rings = new Array<RadarRing>();

    const quadrants = new Array<RadarQuadrant>();

    const entries = new Array<RadarEntry>();

    let radarObj: TechRadarLoaderResponse = {
      rings,
      quadrants,
      entries,
    };
    const url = `${this.backendBaseUrl}/api/techradar-git/${id}`;
    const { token } = await this.identityApi.getCredentials();
    await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => response.text())
      .then(responseString => {
        const responseJson = JSON.parse(responseString, this.reviver);
        // Access the data property first
        const data = responseJson.data || responseJson;
        data.entries.forEach((element: RadarEntry) => {
          entries.push(element);
        });
        data.quadrants.forEach((element: RadarQuadrant) => {
          quadrants.push(element);
        });
        data.rings.forEach((element: RadarRing) => {
          rings.push(element);
        });
        radarObj = {
          quadrants,
          rings,
          entries,
        };
        return radarObj;
      })
      .catch();
    return radarObj;
  }

  reviver(key: string, value: string) {
    if (key === 'date') {
      return new Date(value);
    }

    return value;
  }
}
